import type { CurrentUser } from '../types/inertia'

// Раскатка PWA: пока пуши приходят через раз, установку приложения и тумблер
// уведомлений видит только владелец — он на них и проверяет. Флаг открывает
// владелец на /owner/settings (Setting#pwa_open), тот же приём, что у двери.
//
// Проверка строгая (=== true), а не `!== false`, как у двери: гостю
// inertia_share долгое время отдавал пустой хэш, и любой отсутствующий проп
// обязан читаться как «закрыто», иначе полоса установки покажется всем на
// первом же экране без флага.
export function pwaVisible(props: Record<string, unknown>): boolean {
  if (props.pwa_open === true) return true

  return (props.current_user as CurrentUser | undefined)?.role === 'owner'
}

// Право на нижние полосы («включите уведомления», «установите приложение»).
// Считает сервер (prompt_banners_allowed? в ApplicationController): полосы
// показываем только человеку с оплаченным пакетом или бронью, а владельцу и
// админу — всегда. Новичку после регистрации просить не о чем.
//
// Проверка строгая (=== true) по той же причине, что и у pwaVisible: гостю
// inertia_share этот проп не отдаёт вовсе, и отсутствующий проп обязан читаться
// как «нельзя».
//
// Гейт отдельный от pwaVisible, а не слитый с ним: pwa_open — про раскатку
// (кому функция вообще доступна), этот — про своевременность просьбы. Точки
// в потоке страницы (плашки, поповер, тумблер) под ним НЕ ходят.
export function promptBannersAllowed(props: Record<string, unknown>): boolean {
  return props.prompt_banners_allowed === true
}
